export const FEE_AGREEMENT_PERCENT = 33.33;
export const GUARANTEE_DAYS = 30;
